import { Close, ShoppingCart, AttachMoney } from "@mui/icons-material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import SyncIcon from '@mui/icons-material/Sync';
import EditNoteIcon from '@mui/icons-material/EditNote';

export interface StatusPedido {
    idStatusPedido: string;
    nroStatusPedido: number;
    descricao: string;
    pode_editar_web:string;
    pode_editar_app:string;
    exibe_web:string;
    exibe_app:string;
    exibe_legenda:string;
}

export const opcoesStatusPedido =
    [
        {  
            id: 1,
            value: 'Salvar como rascunho',     
            editavel: true,
            nroStatusPedido: 10,
            color:"#A1A1A1FF", //"#D3D3D3"
            icon: <NoteAltIcon />
        },
        {
            id: 2,
            value: 'Salvar como orçamento',
            editavel: true,
            nroStatusPedido: 20,
            color: "#F8E16C",//"#808080"
            icon: <AttachMoney />
        },
        {
            id: null,
            value: 'Salvar pedido',
            editavel: false,
            nroStatusPedido: 30,
            color: "#F8C36EFF",//"#000000"
            icon: <ShoppingCart  />
        },
        {
            id: 3,
            value: 'Salvar como Sincronizar - ERP',
            editavel: true,
            nroStatusPedido: 60,
            color: "#368900",
            icon: <CloudDownloadIcon  />
        },
        {
            id: null,
            value: null,
            editavel: false,
            nroStatusPedido: 70,
            color: "#63AEE0FF",//"#0000FF"
            icon: <CloudDownloadIcon  />
        },
        {
            id: null,
            value: null,
            editavel: false,
            nroStatusPedido: 80,
            color: "#67B472FF",//"#FF0000"
            icon: <DescriptionIcon />
        },
        {
            id: 0,
            editavel: false,
            value: 'Cancelar Pedido',
            nroStatusPedido: 90,
            color: "#EB5757",//"#FFFF00"
            icon: <Close  />
        },
        {
            id: null,
            editavel: false,
            value: 'Sincronizado',
            nroStatusPedido: 65,
            color: "#7E7B7BFF",//"#FFFF00"
            icon: <SyncIcon />
        },
        {
            id: null,
            editavel: true,
            value: 'Revisar',
            nroStatusPedido: 75,
            color: "#575651FF",//"#FFFF00"
            icon: <EditNoteIcon  />
        }
        
    ]


